import React, { Component, KeyboardEventHandler } from "react";
import { Button, FormControl, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt, faCamera, faBinoculars } from "@fortawesome/free-solid-svg-icons";
import "../../assets/css/attrib-cards.css";
import AppConfig from "../AppConfig/AppConfig.js";
import AuthService from "../AuthService/AuthService.js";
import GlasschainHttpClient from "../ApiService/GlasschainHttpClient.js";
import { toCardId } from "./AttribCardUtils.js";

import CreatableSelect from "react-select/creatable";
import { throttlingRetryPolicy } from "@azure/core-http";

Object.byString = function (o, s) {
  s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
  s = s.replace(/^\./, ""); // strip a leading dot
  var a = s.split(".");
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (k in o) {
      o = o[k];
    } else {
      return;
    }
  }
  return o;
};

const components = {
  DropdownIndicator: null,
};

const createOption = (label) => ({
  label,
  value: label,
});

export default class MultiPalletLookupCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardState: "untouched",
      cardValue: [],
      lookupButtonEnabled: false,
      inLookup: false,
      lookupError: false,
      lookupErrMsg: "",
      inputValue: "",
      value: [],
    };
    this.appConfig = new AppConfig();
    this.auth = new AuthService();
    this.apiClient = new GlasschainHttpClient();
    this.gcid = this.auth.getGcid();
    this.Id = toCardId(this.props.attribTitle);

    this.renderState = this.renderState.bind(this);
    this.renderUntouchedState = this.renderUntouchedState.bind(this);
    this.renderActiveState = this.renderActiveState.bind(this);
    this.onCardClick = this.onCardClick.bind(this);
    this.onLoseFocus = this.onLoseFocus.bind(this);
    this.onValueChange = this.onValueChange.bind(this);
    this.mapEntityFields = this.mapEntityFields.bind(this);
    this.onLookupButtonClick = this.onLookupButtonClick.bind(this);

    this.setCardValue = this.setCardValue.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);

    this.parseType = this.props.parseType;
    this.fieldMap = this.props.fieldMap;
  }

  componentDidUpdate(prevProps, prevState) {
    let oldVal = prevState.cardValue;
    let newVal = this.props.valueBag[this.Id];
    //console.log("Id: " + this.Id + " Old: " + oldVal + " New: " + newVal);
    if (oldVal !== newVal) {
      this.setState({
        cardValue: newVal,
      });
      if (this.state.cardState !== "active") {
        this.setState({ cardState: newVal ? "touched" : "untouched" });
      }
    }
  }

  async onLookupButtonClick() {
    // only works if we have a value to look up!
    if ((!this.state.cardValue) || (this.state.cardValue.length<1)) 
    {
        this.setState({
            lookupError: true,
            lookupErrMsg: "Please enter a value and hit enter or tab to register it."
        });
        return;
    }
    var val = this.state.cardValue[0]; // only use the first pallet
    // confirm they have access to this adapter and role
    if (!this.appConfig.hasAdapterProxyRole(this.gcid, this.props.proxyClientRole)) 
    {
      this.setState({ palletTagButtonEnabled: false });
      return;
    }
    this.setState({ inLookup: true });
    let hasEntityResult = await this.apiClient.hasProxyEntity
    (
      this.gcid,
      this.props.entityExistsApiUrl,
      val
    );
    console.log("has entity? " + hasEntityResult);
    if (!hasEntityResult) {
      this.setState({
        lookupErrMsg: "Unable to locate " + val,
        lookupError: true,
        inLookup: false,
        lookupButtonEnabled: true,
      });
    } else {
      var entityResult = await this.apiClient.fetchProxyEntity(
        this.gcid,
        this.props.entityLookupApiUrl,
        val
      );
      var entity = entityResult;
      // now map entity values to onValueChange for each mapped field
      this.mapEntityFields(entity);
      this.setState({
        lookupErrMsg: "",
        lookupError: false,
        lookupButtonEnabled: true,
        inLookup: false,
      });
      this.props.onValueChange(this.Id, this.state.cardValue);
    }
  }

  mapEntityFields(entity) {
    console.log("returned entity: ");
    console.log(entity);
    for (var key in this.props.fieldMap) {
      let entityField = this.props.fieldMap[key];
      var val = Object.byString(entity, entityField);
      console.log(
        "attempting to get val for key " +
          key +
          " from entity field " +
          entityField
      );
      if (val) {
        console.log("attempting to update " + key + " with " + val);
        this.props.onValueChange(key, val);
      }
    }
  }

  onValueChange(ev) {
    var newLookupButtonEnabled = ev.target.value !== "";
    this.setState({
      inLookup: false,
      lookupError: false,
      lookupErrMsg: "",
      cardValue: ev.target.value,
      lookupButtonEnabled: newLookupButtonEnabled,
    });
    this.props.onValueChange(this.Id, this.state.value);
  }

  onLoseFocus() {
    var newCardState = this.state.cardValue ? "touched" : "untouched";
    this.setState({ cardState: newCardState });
  }

  onCardClick(ev) {
    var newState = "untouched";
    if (this.state.cardState === "active") {
      newState = this.state.cardValue ? "touched" : "untouched";
    } else {
      newState = "active";
    }
    this.setState({ cardState: newState });
    this.props.onToggleCard(this);
  }

  renderUntouchedState() {
    return (
      <div
        className="nonactivecard card-template shadow6"
        onClick={this.onCardClick}
      >
        {this.props.attribTitle}
      </div>
    );
  }



  setCardValue(listValue)
  {
    var newCardValue = (listValue) ? listValue.map((v) => v.value) : [];
    console.log("Set Card Value:");
    console.info(newCardValue)
    this.setState({ cardValue: newCardValue });
    this.props.onValueChange(this.Id, newCardValue);
  }


  handleKeyDown = (event) => {
    const { inputValue, value } = this.state;
    if (!inputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        console.group("Value Added");
        console.log(value);
        console.groupEnd();
        var newValue = [];
        if (this.state.value !== null) 
        {
            this.setState({
                lookupError: false,
                lookupErrMsg: ""
            });
            newValue = [...value, createOption(inputValue)];
            this.setState({
            inputValue: "",
            value: newValue,
            lookupButtonEnabled: true,
          });
        }
        else 
        {
          newValue = [createOption(inputValue)];
          this.setState({
            inputValue: "",
            value: newValue,
            lookupButtonEnabled: true,
          });
        }
        this.setCardValue(newValue);
        event.preventDefault();
    }
  };

  handleChange = (value, actionMeta) => {
    console.group("Value Changed");
    console.log(value);
    console.log(`action: ${actionMeta.action}`);
    console.groupEnd();
    this.setState({ value });
    this.setCardValue(value);
  };

  handleInputChange = (inputValue) => {
    this.setState({ inputValue });
  };

  renderActiveState() {
    const { inputValue, value } = this.state;

    const lookupIcon = this.state.inLookup ? 
    (
        <span>
          <FontAwesomeIcon icon={faSyncAlt} color="lightgreen" spin={true} />
          &nbsp;searching
        </span>
      ) : 
      (
        <span>
          <FontAwesomeIcon icon={faBinoculars} color="white" />
          &nbsp;&nbsp;Lookup
        </span>
      );
  
      const lookupError = this.state.lookupError ? 
      (
        <div align="center" style={{ fontColor: "yellow" }}>
          {this.state.lookupErrMsg}
        </div>
      ) : 
      (
        <span />
      );

    return (
      <div className="activecard shadow6 card-template textcard-input">
        <div onClick={this.onCardClick}>
          {this.props.attribTitle.toLowerCase()}
          {/* {this.renderCameraIcon()} */}
        </div>
        <InputGroup size="sm" style={{ padding: "2px" }}>

          <CreatableSelect
            components={components}
            inputValue={inputValue}
            isClearable
            isMulti
            menuIsOpen={false}
            onChange={this.handleChange}
            onInputChange={this.handleInputChange}
            onKeyDown={this.handleKeyDown}
            placeholder="Input pallet and hit enter"
            value={value}
          />


        &nbsp;&nbsp;
        <Button
            id="palletLookupButton"
            onClick={(ev) => {
              this.onLookupButtonClick(ev);
            }}
          >
            {lookupIcon}
          </Button>
          &nbsp;&nbsp;
          
          {lookupError}
        </InputGroup>
      </div>
    );
  }

  renderCameraIcon = () => {
    return (
      <FontAwesomeIcon
        icon={faCamera}
        color="yellow"
        size="2x"
        style={{ float: "left", paddingLeft: "5px" }}
        onClick={(ev) => this.onCameraClick(ev)}
      />
    );
  };

  onCameraClick(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    this.props.onRequestCameraDialogOpen(this.Id);
  }

  renderTouchedState() {
    return (
      <div
        className="nonactivecard card-template touchedcard shadow7"
        onClick={this.onCardClick}
        style={{ backgroundColor: "lightgreen" }}
      >
        <div style={{ fontSize: "20px" }}>
          {this.props.attribTitle.toUpperCase()}
        </div>
        <div
          style={{
            textAlign: "center",
            fontSize: "20px",
            fontColor: "purple",
          }}
        >
          {this.state.cardValue.join(' ')}
        </div>
      </div>
    );
  }

  renderState() {
    switch (this.state.cardState) {
      case "untouched":
        return this.renderUntouchedState();
      case "touched":
        return this.renderTouchedState();
      default:
        return this.renderActiveState();
    }
  }

  render() {
    return this.renderState();
  }
}
